import React, { Component } from 'react';

import CareerItem from './CareerItem';

export default class Career extends Component {
	render() {
		return (
			<section id="about">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 text-center">
							<h2 className="section-heading">About</h2>
							<h3 className="section-subheading text-muted"></h3>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12">
							<ul className="timeline">
								<CareerItem
									title="Begin Undergraduate at Stevens"
									description=""
									date="Fall of 2014"
									timelineImage="img/about/stevens.png"
									imgAlt="Images of Stevens logo" />
								<CareerItem
									title="Credit Agricole - IT Security Engineer Co-op"
									description=""
									date="Summer of 2015"
									timelineImage="img/about/credit_agricole.svg"
									imgAlt="Credit Agricole logo" />
								<CareerItem
									title="Mckinsey & Company - Mobile Engineer Co-op"
									description=""
									date="Spring of 2016"
									timelineImage="img/about/mckinsey.jpg"
									imgAlt="McKinsey logo" />
								<CareerItem
									title="Nokia Bell Labs - Software Developer Co-op"
									description=""
									date="Fall of 2016 & Summer of 2017"
									timelineImage="img/about/nokia_bell_labs.jpeg"
									imgAlt="Nokia Bell Labs logo" />
								<CareerItem
									title="ActionIQ - Full-stack Web Developer Internship"
									description=""
									date="Winter-Summer 2018"
									link="https://www.actioniq.com"
									timelineImage="img/about/actioniq.jpg"
									imgAlt="ActionIQ logo" />
								<CareerItem
									title="ActionIQ - Software Engineer"
									description=""
									date="Summer 2019-Winter 2022"
									link="https://www.actioniq.com"
									timelineImage="img/about/actioniq.jpg"
									imgAlt="ActionIQ logo" />
                <CareerItem
									title="Attentive Mobile - Software Engineer"
									description=""
									date="Winter 2022-Fall 2024"
									link="https://www.attentivemobile.com/"
									timelineImage="img/about/attentive_mobile.jpg"
									imgAlt="Attentive Mobile logo" />
								<CareerItem
									title="Doordash - Software Engineer"
									description=""
									date="Fall 2024-Present"
									link="https://www.doordash.com/"
									timelineImage="img/about/doordash.png"
									imgAlt="Doordash logo" />
								<li className="timeline-inverted">
									<div className="timeline-image">
										<img className="img-circle img-responsive" src="img/Biz.jpg" alt="My Profile Picture" />
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/Career.jsx